// Proxy service per chiamate Gemini tramite Supabase Edge Function
// Nasconde le chiavi API dal frontend

import { supabase } from '../config/supabase';

const USE_PROXY = process.env.REACT_APP_USE_GEMINI_PROXY === 'true';

/**
 * Chiama Gemini API tramite Supabase Edge Function (proxy sicuro)
 */
export const callGeminiViaProxy = async ({
  model,
  version = 'v1beta',
  prompt,
  systemInstruction = null, // Nuovo: istruzioni statiche per cache optimization
  generationConfig,
  context = 'free_text_search',
  keyLabel = null,
  provider = 'gemini' // 'gemini', 'deepseek', o 'huggingface'
}) => {
  if (!USE_PROXY) {
    return null; // Fallback a chiamata diretta
  }

  try {
    console.log(`[AI Proxy] 🔄 Tentativo chiamata via proxy (${provider})...`);
    
    // Costruisci body, includendo systemInstruction solo se presente (evita null)
    const requestBody = {
      model,
      version,
      prompt,
      generationConfig,
      context,
      keyLabel,
      provider
    };
    
    // Aggiungi systemInstruction solo se presente (non null/undefined)
    if (systemInstruction) {
      requestBody.systemInstruction = systemInstruction;
    }
    
    console.log(`[AI Proxy] 📤 Request body:`, {
      model,
      provider,
      context,
      hasPrompt: !!prompt,
      promptLength: prompt?.length || 0,
      hasSystemInstruction: !!systemInstruction,
      systemInstructionLength: systemInstruction?.length || 0
    });
    
    const { data, error } = await supabase.functions.invoke('gemini-proxy', {
      body: requestBody
    });

    if (error) {
      console.error('[AI Proxy] ❌ Errore proxy:', error);
      // Se è un errore HTTP, logga anche lo status
      if (error.status) {
        console.error(`[AI Proxy] Status code: ${error.status}`);
        if (error.status === 402) {
          console.error('[AI Proxy] ⚠️ Errore 402: Payment Required - Verifica crediti account o chiave API');
        }
      }
      console.log('[AI Proxy] ⚠️ Fallback a chiamata diretta');
      return null; // Fallback a chiamata diretta
    }

    if (data && data.error) {
      console.error('[AI Proxy] ❌ Errore nella risposta:', data.error);
      if (data.status) {
        console.error(`[AI Proxy] Status code: ${data.status}`);
      }
      if (data.errorDetails) {
        console.error('[AI Proxy] Dettagli errore:', data.errorDetails);
      }
      console.log('[AI Proxy] ⚠️ Fallback a chiamata diretta');
      return null; // Fallback a chiamata diretta
    }

    console.log('[Gemini Proxy] ✅ Risposta ricevuta dal proxy');
    return data;
  } catch (error) {
    console.error('[Gemini Proxy] ❌ Exception:', error);
    console.log('[Gemini Proxy] ⚠️ Fallback a chiamata diretta');
    return null; // Fallback a chiamata diretta
  }
};

export default {
  callGeminiViaProxy
};

